module.exports = __webpack_public_path__ + "img/logo-rodape.58368046.png";